// extracted by mini-css-extract-plugin
module.exports = {"support":"SupportDock_support__3Yvr0","chat":"SupportDock_chat__vaf3S","phone":"SupportDock_phone__3cGmf","chatText":"SupportDock_chatText__2tL9X"};